
define('text!modules/user/templates/badge.html',[],function () { return '{{#username}}\n<div class="w-box w-UserBadge">\n<ul class="actions">\n\t\t<li class="user-name">{{username}}</li>\n\t\t<li class="action">\n\t\t\t<a href="#logout" class="logout">Log Out</a>\n\t\t</li>\n\t</ul>\n</div>\n{{/username}}\n\n';});

